import { useState, useCallback } from 'react';
import { POINT_TYPES } from '../utils/constants';

/**
 * Hook für Punkt-Einstellungen
 *
 * Rhino-Verhalten: Punkte sind einfach 3D-Koordinaten (x, y, z).
 * Z ist standardmäßig 0 in der Planansicht (2D).
 *
 * Einstellungen:
 * - Wandtrennend ja/nein (Klick auf Wand teilt diese)
 * - Punkt-Typ (Wall/Auxiliary) - für Building-Layer
 */
export function usePointSettings() {
  // Wandtrennend: Wenn true, wird beim Klick auf eine Wand diese geteilt
  const [wallSplitting, setWallSplitting] = useState(true);

  // Punkt-Typ (wall = raumbildend, auxiliary = Hilfspunkt)
  const [pointType, setPointType] = useState(POINT_TYPES.WALL);

  // Toggle Wandteilung
  const toggleWallSplitting = useCallback(() => {
    setWallSplitting(prev => !prev);
  }, []);

  // Toggle Punkt-Typ
  const togglePointType = useCallback(() => {
    setPointType(prev =>
      prev === POINT_TYPES.WALL ? POINT_TYPES.AUXILIARY : POINT_TYPES.WALL
    );
  }, []);

  return {
    // State
    wallSplitting,
    pointType,

    // Setters
    setWallSplitting,
    setPointType,

    // Toggles
    toggleWallSplitting,
    togglePointType,

    // Helpers
    isAuxiliary: pointType === POINT_TYPES.AUXILIARY,
  };
}
